export default {"src":"/_next/static/media/TotalOrderAmountIcon.21309771.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};